'use strict';
/*

  To use this input widget adapter you need to register it with your
  adapter registry.

*/

import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import { createVNode, createComponentVNode } from "inferno";
import { Component } from 'inferno';
import { DragNDrop } from './DragNDrop';
import { IFileUploadUtil } from '../../interfaces';
import { Button } from 'inferno-bootstrap'; // Placeholder

var FileUploadWidget = /*#__PURE__*/function (_Component) {
  _inherits(FileUploadWidget, _Component);

  function FileUploadWidget(props) {
    var _this;

    _classCallCheck(this, FileUploadWidget);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FileUploadWidget).call(this, props));
    _this.state = {
      progress: undefined,
      errMsg: undefined
    };
    _this.didClick = _this.didClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.doUpload = _this.doUpload.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.didGetProgress = _this.didGetProgress.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.doClearError = _this.doClearError.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(FileUploadWidget, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.value !== undefined && this.state.progress !== undefined) {
        this.setState({
          progress: undefined,
          errMsg: undefined
        });
      }
    }
  }, {
    key: "didClick",
    value: function didClick(e) {
      var _this2 = this;

      e && e.preventDefault();

      if (this.props.onClick) {
        this.props.onClick(e);
      } else {
        var input = document.createElement('input');
        input.type = 'file';

        input.onchange = function (e) {
          _this2.doUpload(e.target.files[0]);
        };

        input.click();
      }
    }
  }, {
    key: "doClearError",
    value: function doClearError(e) {
      e.preventDefault();
      this.setState({
        progress: undefined,
        errMsg: undefined
      });
    }
  }, {
    key: "didGetProgress",
    value: function didGetProgress(perc) {
      this.setState({
        progress: perc,
        errMsg: undefined
      });
    }
  }, {
    key: "doUpload",
    value: function doUpload(uploadObj) {
      var _this3 = this;

      var file;

      if (uploadObj instanceof FileList) {
        // Upload first file in list
        // TODO: Should we support multiple file uploads?
        file = uploadObj[0];
      } else if (uploadObj instanceof File) {
        file = uploadObj;
      } // Fire change event on currently active element to trigger update of value


      this._inputEl.focus();

      this.setState({
        progress: 0
      });
      var fileUploadUtil = registry.getUtility(IFileUploadUtil, this.props.uploadUtilName || 'Image');
      fileUploadUtil.upload(file, this.didGetProgress).then(function (data) {
        _this3.setState({
          progress: 100
        });

        _this3.props.onChange(_this3.props.name, data);
      }).catch(function (e) {
        _this3.setState({
          errMsg: e.message
        });
      }); // TODO: Handle error
    }
  }, {
    key: "renderProgress",
    value: function renderProgress() {
      return createVNode(1, "div", "InfernoFormlib-FileUploadWidget", createVNode(1, "div", "Uploading", createVNode(1, "div", "ProgressContainer", createVNode(1, "div", "ProgressBar", null, 1, {
        "style": {
          width: this.state.progress + '%'
        }
      }), 2), 2), 2);
    }
  }, {
    key: "renderError",
    value: function renderError() {
      return createVNode(1, "div", "InfernoFormlib-FileUploadWidget", createVNode(1, "div", "Error", createVNode(1, "div", "ErrorContainer", [createVNode(1, "p", null, this.state.errMsg, 0), createComponentVNode(2, Button, {
        "onClick": this.doClearError,
        "size": "sm",
        children: "Try again!"
      })], 4), 2), 2);
    }
  }, {
    key: "renderEmpty",
    value: function renderEmpty() {
      var _this4 = this;

      return createVNode(1, "div", "InfernoFormlib-FileUploadWidget", [!this.props.value && createComponentVNode(2, DragNDrop, {
        "onDrop": this.doUpload,
        children: [!this.props.hide && createVNode(1, "span", "placeholder", this.props.placeholder, 0), !this.props.hide && createVNode(64, "input", "form-control-file", null, 1, {
          "id": this.props.id,
          "name": this.props.name,
          "type": "file",
          "aria-label": this.props.name || 'file',
          "onClick": this.didClick,
          "onChange": function onChange(e) {
            e.preventDefault();

            _this4.doUpload(e.target.files[0]);
          }
        }, null, function (el) {
          return _this4._inputEl = el;
        })]
      }), this.props.value && this.props.children], 0);
    }
  }, {
    key: "render",
    value: function render() {
      if (this.props.value) {
        return this.props.children;
      } else if (this.state.errMsg) {
        return this.renderError();
      } else if (this.state.progress !== undefined) {
        return this.renderProgress();
      } else {
        return this.renderEmpty();
      }
    }
  }]);

  return FileUploadWidget;
}(Component);

export default FileUploadWidget;